export const ProjectCard = ({ title, description, imgUrl, projectUrl, isExternal }) => {
    const handleClick = () => {
        if (isExternal) {
            window.open(projectUrl, '_blank', 'noopener,noreferrer');
        }
    };
    return (
        <div 
            className="proj-imgbx clickable-card" 
            onClick={handleClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleClick();
                }
            }}
            aria-label={`View ${title} project`}
        >
            <img src={imgUrl} alt={title} />
            <div className="proj-txtx">
                <h4>{title}</h4>
                <span>{description}</span>
            </div>
        </div>
    );
};